module.exports = __webpack_public_path__ + "img/tree-01-e-leaves.d23a7acd.png";